import React, { useEffect, useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { Download } from 'react-feather';
import QRCode from 'qrcode';

// Genera el QR enteramente en el navegador (sin backend ni servicios de terceros)
const QrCodeModal = ({ show, onHide, url, filename }) => {
  const [dataUrl, setDataUrl] = useState('');

  useEffect(() => {
    if (!show || !url) return;

    let cancelled = false;
    QRCode.toDataURL(url, { width: 480, margin: 2 })
      .then((generated) => {
        if (!cancelled) setDataUrl(generated);
      })
      .catch(() => {
        if (!cancelled) setDataUrl('');
      });

    return () => { cancelled = true; };
  }, [show, url]);

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Tu código QR</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        {dataUrl ? (
          <img src={dataUrl} alt="Código QR del perfil" style={{ maxWidth: '100%', width: 280 }} />
        ) : (
          <Spinner animation="border" />
        )}
        <p className="text-muted small mt-3 mb-0">{url}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Cerrar</Button>
        <Button
          variant="primary"
          disabled={!dataUrl}
          href={dataUrl}
          download={`${filename || 'perfil'}-qr.png`}
        >
          <Download size={16} className="me-2" />
          Descargar PNG
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default QrCodeModal;
